export const GHG_BY_IMPACT_SOLUTION = 1217
export const GHG_BY_COMPANY = 1218
